import { useState } from "react";

// Five clickable stars (the 2.0 take on 1.0's ASPnetRater control on
// CDCompanyDetails). Click a star to set the rating; click the current
// rating again to clear it. Hover previews.

function StarRating({ value, onChange, size = "1.35rem" }) {
  const [hover, setHover] = useState(null);
  const current = Number(value) || 0;
  const shown = hover ?? current;

  return (
    <span
      className="d-inline-flex align-items-center gap-1"
      onMouseLeave={() => setHover(null)}
      role="radiogroup"
      aria-label="Rating"
    >
      {[1, 2, 3, 4, 5].map((n) => (
        <span
          key={n}
          role="radio"
          aria-checked={current === n}
          data-hint={`${n} star${n === 1 ? "" : "s"}${current === n ? " — click to clear" : ""}`}
          style={{ fontSize: size, cursor: "pointer", lineHeight: 1 }}
          className={n <= shown ? "text-warning" : "text-body-tertiary"}
          onMouseEnter={() => setHover(n)}
          onClick={() => onChange(current === n ? "" : n)}
        >
          ★
        </span>
      ))}
      {current > 0 ? (
        <span className="small text-muted ms-1">{current}/5</span>
      ) : (
        <span className="small text-muted ms-1">not rated</span>
      )}
    </span>
  );
}

// Read-only star display for list cells.
export function Stars({ value }) {
  const n = Number(value) || 0;
  if (n <= 0) return <span className="text-muted">-</span>;
  return (
    <span className="text-warning text-nowrap" data-hint={`${n}/5`}>
      {"★".repeat(Math.min(5, n))}
      <span className="text-body-tertiary">{"★".repeat(Math.max(0, 5 - n))}</span>
    </span>
  );
}

export default StarRating;
